import { BaseOtelService } from './BaseOtelService/BaseOtelService.mjs';
import { NoopMeterProvider } from './NoopMeterProvider.mjs';

class NoopOtelService extends BaseOtelService {
  /**
   * Bootstraps an Otel exporter which can send Otel metrics to a dedicated Shopify supported collector endpoint.
   */
  constructor({
    serviceName = 'noop',
    ...options
  }) {
    super({
      serviceName,
      meterProvider: new NoopMeterProvider(),
      ...options
    });
  }
}

export { NoopOtelService };
